import React from "react";
import style from "./index.module.scss";
import moment from "moment";

interface BadgeCorProps {
    timeDate?: string;
    beginTime: string;
    endTime: string;
}

export default function BadgeCor({
    timeDate,
    beginTime,
    endTime
}: BadgeCorProps) {
    //获取时间并且格式化
    const date = moment(timeDate).format("YYYY-MM-DD");
    //课程开始时间
    const before = date + " " + beginTime;
    const beforeTime = moment(before);
    //课程结束时间
    const after = date + " " + endTime;
    const afterTime = moment(after);

    function renderBadge() {
        if (afterTime.isBefore(moment()))
            return (
                <div className={`${style.badge} ${style.end}`}>
                    <p>已结束 </p>
                </div>
            );

        if (beforeTime.isAfter(moment()))
            return (
                <div className={`${style.badge} ${style.noStart}`}>
                    <p>未开始</p>
                </div>
            );

        return (
            <div className={style.badge}>
                <p>进行中</p>
            </div>
        );
    }

    return <div>{renderBadge()}</div>;
}
